import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const getStateSlice = (state) => state.api.network.dns.domain.enablePrivacy;

const { actions, reducer, sagas, selectors } = createAPIModule({
	getStateSlice,
	actionType: 'NETWORK_DNS_DOMAIN_ENABLEPRIVACY',
	method: 'POST',
	url: '/network/dns/domain/enablePrivacy.json',
});

export { actions, reducer, sagas, selectors };
